import React from 'react';
import { Row, Col, message, Popconfirm } from 'antd';
import { getStringLength } from 'utils/utils.js';
import { connect } from 'dva';
import styles from './Index.less';
import SkusChildItem from './SkusChildItem/Index.js';
import EditModal from '../EditModal.js';

@connect(() => ({}))
export default class SkusItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleModalOk = this.handleModalOk.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
    this.handleAddSkusChild = this.handleAddSkusChild.bind(this);
    this.handleEditSkus = this.handleEditSkus.bind(this);
    this.handleDelSkus = this.handleDelSkus.bind(this);

    this.state = {
      modalVisible: false,
      modalTitle: '',
      modalInputPlaceholder: '',
      modalInputValue: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMsg !== '') {
      message.warning(nextProps.errorMsg);
    }
  }

  handleModalOk(_value) {
    const { parentSkusLength } = this.props;
    const value = _value.trim();

    if (value === '') {
      return message.warning(`规格名称不能为空`);
    }

    if (getStringLength(value) > parentSkusLength * 2) {
      return message.warning(`规格名称不能超过${parentSkusLength}字`);
    }
    if (this.props.lastName === value) {
      return this.setState({
        modalVisible: false,
      });
    }
    this.props.dispatch({
      type: 'SkusEdit/modifySkus',
      option: 'change',
      payload: {
        lastName: this.props.lastName,
        name: value,
      },
    });

    this.setState({
      modalVisible: false,
    });
  }

  handleModalCancel() {
    this.setState({
      modalVisible: false,
    });
  }

  handleAddSkusChild() {
    this.props.dispatch({
      type: 'SkusEdit/modifySkusChild',
      option: 'add',
      payload: {
        parentName: this.props.name,
        value: '',
      },
    });
  }

  handleEditSkus() {
    this.setState({
      modalVisible: true,
      modalTitle: '编辑',
      modalInputPlaceholder: '',
      modalInputValue: this.props.name,
    });
  }

  handleDelSkus() {
    this.props.dispatch({
      type: 'SkusEdit/modifySkus',
      option: 'delete',
      payload: {
        name: this.props.name,
      },
    });
  }

  render() {
    const { name, childList, type, childSkusLength } = this.props;
    const { modalVisible, modalTitle, modalInputPlaceholder, modalInputValue } = this.state;
    const childItemList = childList.map(item => {
      return (
        <SkusChildItem
          key={item.value}
          type={type}
          id={item.id}
          value={item.value}
          lastValue={item.lastValue}
          parentName={name}
          errorMsg={item.errorMsg}
          childSkusLength={childSkusLength}
        />
      );
    });

    return (
      <div className={styles['skus-item-container']}>
        <Row>
          <Col span={20}>
            <p className={styles['skus-item-text']}>{name}</p>
          </Col>
          {type === 'edit' ? (
            <Col span={4} className={styles['skus-item-btnGroup']}>
              <span className={styles['skus-item-btn-edit']} onClick={this.handleEditSkus}>
                编辑
              </span>
              <Popconfirm title="是否删除此规格？" onConfirm={this.handleDelSkus}>
                <a href="#" className={styles['skus-item-btn-del']}>
                  删除
                </a>
              </Popconfirm>
            </Col>
          ) : null}
        </Row>
        <div className={styles['skus-child-container']}>
          {childItemList}
          {type === 'edit' ? (
            <div className={styles['skus-child-addBtn-container']}>
              <span className={styles['skus-child-addBtn-text']} onClick={this.handleAddSkusChild}>
                + 添加
              </span>
            </div>
          ) : null}
        </div>
        {/* 对话框 */}
        {type === 'edit' ? (
          <EditModal
            modalVisible={modalVisible}
            modalTitle={modalTitle}
            modalInputPlaceholder={modalInputPlaceholder}
            inputValue={modalInputValue}
            onOk={this.handleModalOk}
            onCancel={this.handleModalCancel}
          />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/SkusEdit/SkusItem/Index.js